import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import {
  IDetailedOrderStatusRequestService,
  CHANNEL_DETAILED_ORDER_STATUS_REQUEST,
} from "../IDetailedOrderStatusRequestService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class DetailedOrderStatusRequestReplicaService
  implements IDetailedOrderStatusRequestService
{
  protected broker: ClientMessageBroker;

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(
      CHANNEL_DETAILED_ORDER_STATUS_REQUEST,
      true,
      true,
    );
  }

  public request(id: string): Promise<CubiqTS.OrderDataImpl> {
    let request = new UiArguments("request");

    request.args = [new FnArg(id, PRIMITIVE)];

    return this.broker.runOnService(request, CubiqTS.ENCODABLE(CubiqTS.OrderDataImpl));
  }

  public requestAdaptedTradeDeals(ids: Array<string>): Promise<any> {
    let request = new UiArguments("requestAdaptedTradeDeals");

    request.args = [new FnArg(ids, PRIMITIVE)];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  public requestMediatedOrderDetails(id: string): Promise<any> {
    let request = new UiArguments("requestMediatedOrderDetails");

    request.args = [new FnArg(id, PRIMITIVE)];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  public releaseMediatedOrderDetails(requestRef: string): Promise<any> {
    let request = new UiArguments("releaseMediatedOrderDetails");

    request.args = [new FnArg(requestRef, PRIMITIVE)];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  public getMediatedOrderData(orderId: string, requestRef: string | null): Promise<any> {
    let request = new UiArguments("getMediatedOrderData");

    request.args = [new FnArg(orderId, PRIMITIVE), new FnArg(requestRef, PRIMITIVE)];

    return this.broker.runOnService(request, CubiqTS.ENCODABLE(CubiqTS.OrderDataImpl));
  }
}
